import { Alert, Snackbar } from "@mui/material";
import { SnackbarSeverity } from "@root/hooks/useSnackbar";

type AppSnackbarProps = {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
  onClose: () => void;
};

export const AppSnackbar = ({
  open,
  message,
  severity,
  onClose,
}: AppSnackbarProps) => (
  <Snackbar
    open={open}
    autoHideDuration={6000}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
  >
    <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>
);
